import React from 'react'
import PropTypes from 'prop-types'
import { Tab, Tabs, Tooltip } from '@material-ui/core'
import helpers from 'helpers'
import constants from 'constants/index'

const ActivitiesTableTabs = ({
  columns,
  currentTab,
  onTabChange,
  hasUnlinked,
  hasSourceRemoved,
}) => {
  const { LINK_STATUS_UNLINKED_VALUE, LINK_STATUS_SOURCE_REMOVED_VALUE } =
    constants.activities

  return (
    <Tabs
      value={currentTab}
      onChange={(_, val) => onTabChange(val)}
      scrollButtons="auto"
      variant="scrollable"
      textColor="primary"
      indicatorColor="primary"
    >
      <Tab label="Todas" value={null} />
      {columns.map((col) => (
        <Tab
          key={col.id}
          value={col.id}
          label={
            col.title.length > 18 ? (
              <Tooltip title={col.title}>
                <span>{helpers.truncateUIText(col.title, 18)}</span>
              </Tooltip>
            ) : (
              helpers.truncateUIText(col.title, 18)
            )
          }
        />
      ))}
      {hasUnlinked && (
        <Tab label="Desvinculadas" value={LINK_STATUS_UNLINKED_VALUE} />
      )}
      {hasSourceRemoved && (
        <Tab label="Origem removida" value={LINK_STATUS_SOURCE_REMOVED_VALUE} />
      )}
    </Tabs>
  )
}

ActivitiesTableTabs.propTypes = {
  columns: PropTypes.array.isRequired,
  currentTab: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onTabChange: PropTypes.func.isRequired,
  hasUnlinked: PropTypes.bool,
  hasSourceRemoved: PropTypes.bool,
}

ActivitiesTableTabs.defaultProps = {
  hasUnlinked: false,
  hasSourceRemoved: false,
}

export default ActivitiesTableTabs
